<a
  class="link-hover no-underline flex flex--middle pr-xxsmall-t"
  [finLink]="ctaButton$ | finMap: 'url' | async"
  [external]="ctaButton$ | finMap: 'external' | async"
  [attr.target]="(ctaButton$ | finMap: 'external' | async) ? '_blank' : ''"
  *ngIf="!!(ctaButton$ | async)"
>
  <span
    class="nordic-blue-900-text text-icon-primary"
    [ngClass]="{
      'font-heading-2 font-headline-medium': !layout,
      'font-heading-3 font-headline-small': layout === 'small',
      'font-body-1 font-body-medium': layout === 'xsmall',
    }"
    *ngIf="teaserTitle$ | async as tt"
    >{{ tt }}
  </span>
  <fcom-icon
    role="presentation"
    class="nordic-blue-900-text text-icon-primary icon-medium"
    [ngClass]="{
      'mr-small-l': !layout,
      'mr-xsmall-l': layout === 'small',
      'ms-xxsmall-l': layout === 'xsmall',
    }"
    [name]="SvgLibraryIcon.ARROW_RIGHT"
  />
</a>
<div class="teaserText mr-xsmall-t" [innerHTML]="teaserText$ | async | finEmpty: false | finSafe: 'html'"></div>
